import React, { useEffect, useState, FC } from "react"
import { KSpan, KTitleSpan } from "kahuna-base-react-components"
import { connect } from "react-redux"
import { RootState } from "../../../../store"
import { checkAdminPermission } from "../../../../utility"
import { ADMIN_PERMISSIONS } from "../../../../constants"
import AdminMissingShareHolders from "./missing-share-holders/AdminMissingShareHolders"
import { fetchMissingTrackShareHolderCount, updateMissingTrackShareHolderCount } from "../../../../actions/adminActions"

enum TabOptions {
  MISSING_SHARE_HOLDERS = "Missing Share Holders"
}

type AdminActionsProps = {
  userAdminPermissions?: string
  missingTrackShareHolderCount: number
  fetchMissingTrackShareHolderCount: () => Promise<void>
  updateMissingTrackShareHolderCount: (count: number) => Promise<void>
}

const AdminActions: FC<AdminActionsProps> = (props) => {
  const [openSidebar, setOpenSidebar] = useState<boolean>(true)
  const [selectedTab, setSelectedTab] = useState(TabOptions.MISSING_SHARE_HOLDERS)

  useEffect(() => {
    if (!props.missingTrackShareHolderCount) {
      fetchMissingTrackShareHolderCount()
    }
  }, [])

  return (
    <div className="catalog flex-grow justify-center">
      <div className="w-[100%] flex ">
        <div
          className={`${
            openSidebar ? "min-w-[230px]" : "min-w-0 !w-[0px]"
          } max-w-[320px] w-[20%] bg-[#F7F7F7] min-h-[100vh] flex flex-col overflow-hidden shrink-0`}
          style={{
            transitionDuration: "0.5s"
          }}
        >
          <div>
            <div className="py-1.5 px-4">
              <div className="p-2">
                <KTitleSpan text="Admin Actions" color="#111" fontSize={20} lineHeight="28px" />
              </div>
              {checkAdminPermission(
                ADMIN_PERMISSIONS.ACTIONS_MISSING_SHARE_HOLDER_READ,
                props.userAdminPermissions
              ) && (
                <div
                  data-testid="left-bar-user-advance"
                  className={`rounded-[10px] p-2 flex flex-row gap-2 mt-4 items-center ${
                    selectedTab === TabOptions.MISSING_SHARE_HOLDERS ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap`}
                  onClick={() => {
                    if (selectedTab === TabOptions.MISSING_SHARE_HOLDERS) return
                    setSelectedTab(TabOptions.MISSING_SHARE_HOLDERS)
                  }}
                >
                  <KSpan
                    text={`Missing Share Holders (${props.missingTrackShareHolderCount})`}
                    fontSize={12}
                    lineHeight="20px"
                    fontWeight={500}
                    color="#111"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="grow min-h-0">
          {selectedTab === TabOptions.MISSING_SHARE_HOLDERS && (
            <AdminMissingShareHolders
              openSidebar={openSidebar}
              setOpenSidebar={setOpenSidebar}
              missingTrackShareHolderCount={props.missingTrackShareHolderCount}
              updateMissingTrackShareHolderCount={props.updateMissingTrackShareHolderCount}
            />
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    userAdminPermissions: state.auth.user.adminPermissions,
    missingTrackShareHolderCount: state.admin.missingTrackShareHolderCount
  }
}

export default connect(mapStateToProps, { fetchMissingTrackShareHolderCount, updateMissingTrackShareHolderCount })(
  AdminActions
)
